module.exports = __webpack_public_path__ + "img/Minus.50754bb0.svg";